import React from "react";
import { Card, Row, Col } from "antd";
import { NavLink } from "react-router-dom"; // Add this line
const { Meta } = Card;

const Reports = () => {
  const reports = [
    {
      id: 1,
      title: "Perfil Cardiovascular",
      previewImage:
        "https://th.bing.com/th/id/OIP.agJV_iSTZTeTs8KmfY1NJgAAAA?rs=1&pid=ImgDetMain",
      description:
        "El perfil cardiovascular es un conjunto de pruebas que se realizan para evaluar el riesgo de enfermedad cardíaca miden los niveles de colesterol, glucosa y triglicéridos en la sangre, la presión arterial y el peso.",
    },
    {
      id: 2,
      title: "Estadisticas de pacientes Ingresados",
      previewImage:
        "https://www.dynamicwebtraining.com.au/blog/wp-content/uploads/2018/11/power-bi-data-analytics-1024x576.png",
      description:
        "Las estadísticas de pacientes ingresados permiten visualizar la cantidad de pacientes que han sido ingresados en un periodo de tiempo determinado.",
    },
    {
      id: 3,
      title: "Estadisticas de pacientes Ingresados",
      previewImage:
        "https://www.coolblue.com/wp-content/uploads/2022/09/Microsoft-Power-BI-Symbol.png",
      description:
        "Las estadísticas de pacientes ingresados permiten visualizar la cantidad de pacientes que han sido ingresados en un periodo de tiempo determinado.",
    },
    // Add more reports as needed
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        {reports.map((report) => (
          <Col span={6} key={report.id}>
            <NavLink
              to={`/admin/reportView/${report.id}`}
              activeClassName="active"
            >
              {" "}
              {/* Add this line */}
              <Card
                hoverable
                style={{ width: 360 }}
                cover={
                  <img
                    alt="example"
                    src={report.previewImage}
                    width={360}
                    height={200}
                  />
                }
              >
                <Meta title={report.title} description={report.description} />
              </Card>
            </NavLink>{" "}
            {/* Add this line */}
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Reports;
